import { render } from "./PromotionsView.vue?vue&type=template&id=1212e822"
import script from "./PromotionsView.vue?vue&type=script&lang=js"
export * from "./PromotionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__